export function normalizeAddress(address: string | null): string {
  if (address && address.includes("tel:")) {
    return address.replace("tel:", "");
  } else {
    return address || ""; // Return an empty string if address is null or doesn't match
  }
}